module.exports = __webpack_public_path__ + "media/images/ui__arrowUp-82204e3f3db948c253eed74205ddcd15.png";